import React from "react";
import { Box, Collapsible, Divider } from "@bca/ui-library";

import { FILTER_NAMES, FILTER_NAMES_FOR_TRACKED } from "./constants";

interface CollapsibleSkeletonProps {
  isTrackedPage: boolean;
}

const CollapsibleSkeleton: React.FC<CollapsibleSkeletonProps> = ({
  isTrackedPage,
}) => {
  const filterNames = isTrackedPage ? FILTER_NAMES_FOR_TRACKED : FILTER_NAMES;
  return (
    <Box display="flex" flexDirection="column">
      {filterNames.map((name, index) => (
        <Box key={index}>
          <Collapsible title={name} disabled />
          {(name === "Derivative" || name === "Sale Channel") && <Divider />}
        </Box>
      ))}
    </Box>
  );
};

export default CollapsibleSkeleton;
